import { render } from "./PatientLabPrint.vue?vue&type=template&id=24096140&scoped=true"
import script from "./PatientLabPrint.vue?vue&type=script&lang=js"
export * from "./PatientLabPrint.vue?vue&type=script&lang=js"

import "./PatientLabPrint.vue?vue&type=style&index=0&id=24096140&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24096140"]])

export default __exports__